<template>
  <div class="page-gray">
    <div class="register">
      <sHeader />
      <div class="mian">
        <div class="title">绑定手机号</div>
        <div class="content">
          <div class="inputK">
            <el-input
              v-model="mobile"
              placeholder="请输入您的手机号"
            ></el-input>
          </div>
          <div class="captcha">
            <el-input
              v-model="captchaText"
              placeholder="请输入验证码"
              name="验证码"
            />
            <img :src="serialImg" alt @click="getCaptcha" />
          </div>
          <div class="captcha">
            <el-input v-model="captcha" placeholder="请输入验证码"></el-input>
            <span @click="flag && sendcode($event)">获取验证码</span>
          </div>
          <div class="agree">
            <el-checkbox @click="CheckItem(Agreement)" v-model="Agreement.state"
              >我已阅读并接受<span class="orange" @click="agree"
                >用户协议</span
              ></el-checkbox
            >
          </div>
          <div class="butn" @click="captchaLogin">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 1.先使用import导入你要在该组件中使用的子组件
import sHeader from "@/components/common/sheader";
import captcha from "@/mixins/captcha";
import { loginApi } from "@/api";
export default {
  mixins: [captcha],
  data() {
    return {
      mobile: "",
      captcha: "",
      flag: true,
      Agreement: {
        state: false
      }
    };
  },
  components: {
    sHeader
  },
  methods: {
    // 判断是否同意协议
    CheckItem(Agreement) {
      Agreement.state = !Agreement.state;
    },
    // 用户协议
    agree() {
      window.location = "https://m.juranguanjia.com/Agreement/m";
    },
    // 发送手机验证码
    async sendcode(event) {
      if (!this.captchaText) {
        this.$message.error("请输入图形验证码！");
        return;
      }
      let el = event.currentTarget;
      let waitTime = 60;
      try {
        let params = {
          mobile: this.mobile,
          smsType: 1,
          captchaSerialNum: this.captchaSerialNum,
          captchaText: this.captchaText
        };
        let data = (await loginApi.sendcode(params)).data;
        if (data.statusCode === 200) {
          this.dingshiqi(el, waitTime);
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    // 定时器
    dingshiqi(el, waitTime) {
      if (waitTime === 0) {
        this.flag = true;
        el.innerHTML = "重新获取验证码";
        waitTime = 60; // 恢复计时
        clearTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
      } else {
        el.innerHTML = waitTime + "s后重新发送";
        waitTime--;
        setTimeout(() => {
          this.dingshiqi(el, waitTime);
        }, 1000);
        this.flag = false;
      }
    },
    // 短信登录
    async captchaLogin() {
      if (this.mobile === "") {
        this.$message.error("您的手机号码不能为空！");
      } else if (!this.mobile.match(/^1[3,4,5,7,8,9]\d{9}$/)) {
        this.$message.error("您的手机号码的格式不正确！");
      } else if (this.captchaLogin === "") {
        this.$message.error("请输入验证码！");
      } else {
        if (this.Agreement.state === true) {
          try {
            let params = {
              mobile: this.mobile,
              verifyCode: this.captcha,
              smsType: 2,
              loginType: 2
            };
            let data = (await loginApi.captchaLogin(params)).data;
            if (data.statusCode === 200) {
              this.USER_SIGNIN(data.data);
              this.$router.push({
                path: "/"
              });
            }
          } catch (err) {
            console.error(err);
          } finally {
          }
        } else {
          this.$message.error("请阅读并同意《熊洞智家用户服务协议》！");
        }
      }
    }
  }
};
</script>

<style scoped>
.page-gray {
  background: #f4f4f4;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}
.register {
  width: 33rem;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  overflow: hidden;
}
.register .mian {
  width: 100%;
  margin-top: 0.52rem;
}
.register .mian .title {
  width: 100%;
  border-radius: 8px 8px 0 0;
  background: #ee8e38;
  color: #ffffff;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  font-size: 0.89rem;
  font-weight: 500;
}
.register .mian .content {
  background: #fff;
  border-radius: 0 0 8px 8px;
  width: 100%;
  padding: 1rem 0;
}
.register .mian .content .inputK {
  width: 100%;
  height: 1.64rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}
.register .mian .content .inputK >>> .el-input,
.register .mian .content .inputK >>> .el-input__inner {
  background: #f4f4f4;
  width: 13rem;
  height: 1.64rem;
  font-size: 0.52rem;
}
.captcha {
  width: 13rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 1rem;
}
.captcha .el-input,
.captcha >>> .el-input__inner {
  width: 7rem;
  height: 1.64rem;
  font-size: 0.52rem;
  background: #f4f4f4;
}
.captcha span {
  width: 5rem;
  height: 1.64rem;
  background: #f4f4f4;
  color: #999999;
  font-size: 0.59rem;
  line-height: 1.64rem;
  text-align: center;
  display: inline-block;
  border-radius: 4px;
}
.agree {
  width: 13rem;
  margin: 0 auto;
  font-size: 0.52rem;
  color: #333333;
  height: 0.52rem;
  line-height: 0.52rem;
  margin-bottom: 1rem;
}
.agree >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
}
.agree .orange {
  color: #ee8e38;
}
.butn {
  width: 13rem;
  margin: 0 auto;
  height: 1.64rem;
  background: #ee8e38;
  color: #ffffff;
  line-height: 1.64rem;
  text-align: center;
  font-size: 0.6rem;
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 1rem;
  cursor: pointer;
}
</style>
